// extracted by mini-css-extract-plugin
export var active = "_de-2";
export var recordingDot = "_de-1";
export var recordingIndicator = "_de-0";